import { StyleMode } from "models/ProfileSettings";

// 'System' leaves data-theme unset so the prefers-color-scheme media query decides
export function applyTheme(theme: StyleMode) {
    if (theme === 'System') {
        delete document.documentElement.dataset.theme;
    } else {
        document.documentElement.dataset.theme = theme.toLowerCase();
    }
}
